import { useFullReleaseStrict } from "@/common/hooks_useFullRelease";

import Typography from "@mui/material/Typography";
import type { RelationshipExpression } from "@packages/compiler";
import { capitalize } from "lodash";
import Icon from "@imminently/decisively-ui/Icon";

const RELATIONSHIP_MAP = {
  true: {
    OneToOne: "To-one",
    OneToMany: "To-one",
    ManyToMany: "To-many",
    ManyToOne: "To-many",
  },
  false: {
    OneToOne: "To-one",
    OneToMany: "To-many",
    ManyToMany: "To-many",
    ManyToOne: "To-one",
  },
};

export const RelationshipInfo = ({ expression }: { expression: RelationshipExpression }) => {
  const { relationshipId } = expression;
  const release = useFullReleaseStrict();
  const relationship = release.relationships.find((r) => r.id === relationshipId);
  if (!relationship) {
    return (
      <div className="flex flex-col p-4">
        <Typography>Relationship (pending document save)</Typography>
      </div>
    );
  }

  const source =
    relationship.source === "global"
      ? relationship.source
      : (release.relationships.find((r) => r.target === relationship.source)?.textSingular ?? "ERROR MISSING");
  const target =
    relationship.textSingular ??
    release.relationships.find((r) => r.target === relationship.target)?.textSingular ??
    "ERROR MISSING";

  const reverse = Boolean(relationship.reverseText);

  const typeText = RELATIONSHIP_MAP[reverse.toString()][relationship.type];

  return (
    <div className="flex flex-col gap-2 p-2">
      <div className="flex items-center gap-1">
        <Typography>
          {reverse ? target : source} ➝ {reverse ? source : target}
        </Typography>
      </div>

      <div className="flex items-center gap-1">
        <Icon name="implementation" style={{ width: "1rem" }} />
        <Typography variant="caption">{typeText} Relationship</Typography>
      </div>
    </div>
  );
};
